import { QueryClientProvider } from "@tanstack/react-query";
import React, { ReactNode, useEffect } from "react";
import { locale, PrimeReactProvider } from "primereact/api";
import { ErrorBoundary } from "@sentry/react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "../services/HttpService";
import { useUserState } from "../store/user-store";
import { logInfo } from "../utils/logging-utils";

type ComponentRootProps = {
  id: string;
  type: string;
  module: any;
  props: any;
}

const  ComponentRoot = (props: ComponentRootProps): ReactNode => {
  const language = useUserState(state => state.getLanguage());

  useEffect(() => {
    locale(language);
  }, [])

  logInfo("ComponentRoot rendered", props)

  return (
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <PrimeReactProvider value={{ zIndex: { overlay: 10000}}}>
            <ErrorBoundary>{React.createElement(props.module.default, props.props)}</ErrorBoundary>
          </PrimeReactProvider>

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    </React.StrictMode>
  )
}

export default ComponentRoot